/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectsEnumChoicesRetrieve$Params {}

export function projectsEnumChoicesRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsEnumChoicesRetrieve$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    [key: string]: any;
  }>
> {
  const rb = new RequestBuilder(rootUrl, projectsEnumChoicesRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        [key: string]: any;
      }>;
    }),
  );
}

projectsEnumChoicesRetrieve.PATH = '/api/projects/enum-choices/';
